// extracted by mini-css-extract-plugin
module.exports = {"guide":"Auth_guide__3eSzv","intro":"Auth_intro__slNQC","intro_1":"Auth_intro_1__2Dz-p","cgs":"Auth_cgs__3BP-9"};